import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RelatedTableConfig } from '../../../config/model/relationship-config.model';
import { DetailViewFeatureParams, RelatedFeatureParams } from '../detail-view.model';
import { LayerInfosService } from '../../../shared/service/layer-infos.service';
import { RelationshipService } from '../../../shared/service/relationship.service';
import { RelatedFeatureFormComponent } from './related-feature-form/related-feature-form.component';
import { RelatedTableActionsService } from './shared/related-table-actions.service';
import { TakeUntilDestroy } from '../../../core/component/take-until-destroy';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'related-table',
  templateUrl: './related-table.component.html',
  styleUrls: ['related-table.component.scss'],
  standalone: false,
})
export class RelatedTableComponent extends TakeUntilDestroy implements OnInit, OnDestroy {
  @ViewChild('relatedFeatureFormRef', { static: false })
  relatedFeatureFormRef: RelatedFeatureFormComponent;
  @Input() featureParams: DetailViewFeatureParams;
  @Input() relatedTableConfig: RelatedTableConfig;
  @Input() relatedTabIndex: number;
  @Input() detailViewExpanded: boolean;

  private relatedLayerUrl: string;

  public relatedFeatures: __esri.Graphic[];
  public selectedRelatedFeature: __esri.Graphic;
  public relatedFeatureParams: RelatedFeatureParams;
  public displayRelatedTable = false;

  constructor(
    private layerInfosService: LayerInfosService,
    private relationshipService: RelationshipService,
    private relatedTableService: RelatedTableActionsService
  ) {
    super();
  }

  ngOnInit() {
    this.relatedFeatureParams = new RelatedFeatureParams();
    this.initialData();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * @name initialData
   * @description load data and init component
   */
  public initialData() {
    // check of valid feature
    if (
      !this.featureParams ||
      !this.featureParams.feature ||
      !this.featureParams.featureLayerUrl ||
      !this.relatedTableConfig
    ) {
      return;
    }

    this.relatedTableService.relationshipInfo = this.relationshipService.getRelationshipInfoOfLayerInfo(
      this.featureParams.layerInfos,
      this.relatedTableConfig.relationshipName
    );

    // get related layer infos
    this.relatedLayerUrl = this.relationshipService.getRelatedLayerUrl(
      this.featureParams.featureLayerUrl,
      this.relatedTableService.relationshipInfo
    );

    this.layerInfosService.getLayerInfos(this.relatedLayerUrl).pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.relatedTableService.relatedRelationshipInfo = result.data.relationships.find(f => {
        return f.relationshipTableId === this.relatedTableService.relationshipInfo.relationshipTableId;
      });

      if (!this.relatedTableService.relatedRelationshipInfo) {
        throw new Error('no relation-info found');
      }

      this.relatedFeatureParams.relatedFields = result.data.fields;
      this.relatedFeatureParams.relatedTableConfig = this.relatedTableConfig;
      this.relatedFeatureParams.relatedLayerUrl = this.relatedLayerUrl;
      this.relatedFeatureParams.relationshipInfo = this.relatedTableService.relationshipInfo;

      this.loadRelatedData();
    });
  }

  /**
   * @name loadRelatedData
   * @description get Data by feature object id from related table
   */
  private loadRelatedData() {
    this.relationshipService
      .queryRelatedFeatures(
        this.featureParams.featureLayerUrl,
        this.relatedTableService.relationshipInfo,
        this.featureParams.feature
      ).pipe(takeUntil(this.unsubscribe$))
      .subscribe((relatedFeatures: __esri.Graphic[]) => {
        this.relatedFeatures = relatedFeatures;

        // select default related feature
        if (this.relatedFeatures.length > 0) {
          setTimeout(() => {
            this.selectedRelatedFeature = this.relatedFeatures[0];
            this.displayRelatedTable = true;
            this.relatedFeatureParams.feature = this.relatedFeatures[0];
          }, 500);
        } else {
          this.displayRelatedTable = false;
        }
      });
  }
}
